<ng-template #attendees let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Edit Event Registration</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		
	</div>
	<div class="modal-body text-dark">
		<div class="row">
		{{selected_event.name}}<br>
		{{selected_event.date_start}} - {{selected_event.date_end}}
		</div>
		<hr>
		<div class="row">
		Seats ({{selected_event.history.seats}}) Confirmation# {{selected_event.history.order_id}}
		</div>
		<div class="row">
		<span [innerHtml]="selected_event.billing_address"></span>
		</div>
		<div class="row">
			Attendees ({{selected_event.history?.registrants?.length}})
		</div>
		<div class="row">
				<div class="col-2"></div>
				<div class="col-3">Name</div>
				<div class="col-3">Phone</div>
				<div class="col-3">Email</div>
				
		</div>			
				
		<form [formGroup]="attendeeForm">
			<div class="row" *ngFor="let attend of selected_event?.history?.registrants; let i = index">
				
					<div class="col-2"><button class="btn btn-sm" (click)="removeReg(attend.name, selected_event.history_id);"><mat-icon>remove</mat-icon></button></div>
					<div class="col-3"><mat-form-field appearance="outline"><input matInput formControlName="name-{{attend.id}}"></mat-form-field></div>
					<div class="col-3"><mat-form-field appearance="outline"><input matInput formControlName="email-{{attend.id}}"></mat-form-field></div>
					<div class="col-3"><mat-form-field appearance="outline"><input matInput formControlName="phone-{{attend.id}}"></mat-form-field></div>
			</div>
			<div class="row">
				<div class="col-3">Notes:</div><div class="col-9"><mat-form-field appearance="outline"><input matInput formControlName="notes"></mat-form-field></div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
	<button type="button" class="btn btn-sm btn-success" aria-label="Close" (click)="saveChanges()"><i class="fa fa-save"></i></button>
	</div>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{ color}}-5">
				<h4 class="card-title">Education Attendees</h4>
				<p class="card-category"></p>
			</div>
			<div class="card-body">
				<form [formGroup]="searchForm" class="m-0 p-0">
			<div class="row m-0 p-0">
				<div class="col-xs-12 col-md-3 col-3">
				<mat-form-field color="accent" class="datepicker" appearance="outline">
                <mat-label>Enter a date range</mat-label>
                <div class="daterange-div">
                    <mat-date-range-input [rangePicker]="picker" class="daterange-input">
                        <input matStartDate placeholder="Start date" formControlName="startdate">
                        <input matEndDate placeholder="End date" formControlName="enddate">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
				</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>City</mat-label>
						<mat-select formControlName="city" multiple appSelectAll>
							<mat-option *ngFor="let v of cities" [value]="v">
								{{v}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Host</mat-label>
						<mat-select formControlName="host" multiple appSelectAll>
							<mat-option *ngFor="let v of hosts" [value]="v">
								{{v}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-md-3 mt-3">
					<span *ngIf="sending">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					<button mat-raised-button class="btn-success btn-height" (click)="$event.preventDefault();exportXls()" *ngIf="sortedReportResults.length != 0">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					&nbsp;
					<button mat-raised-button class="btn-danger btn-height" (click)="$event.preventDefault();exportPdf()" *ngIf="sortedReportResults.length != 0">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
					&nbsp;
					<button mat-raised-button color="accent" class="mt-2" (click)="search()" *ngIf="!sending">
						<mat-icon>refresh</mat-icon>
					</button>
				</div>
			</div>
			<div class="row m-0 p-0">
			<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Sales Person</mat-label>
						<mat-select formControlName="salesperson" multiple appSelectAll>
							<mat-option *ngFor="let v of salespeople" [value]="v.salesmancode">
								{{v.salesmanname}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			
			<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Status</mat-label>
						<mat-select formControlName="status" multiple appSelectAll>
							<mat-option [value]="0">
								Disabled
							</mat-option>
							<mat-option [value]="1">
								Enabled
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Year</mat-label>
						<mat-select formControlName="year" multiple appSelectAll>
							<mat-option *ngFor="let v of years" [value]="v">
								{{v}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Event</mat-label>
						<mat-select formControlName="event" multiple appSelectAll>
							<mat-option *ngFor="let v of events" [value]="v.id">
								{{v.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			</form>
			</div>


	<div>
		<table class="table table-striped table-bordered table-hover table-fixed" *ngIf="!loading">
			<thead>
				<tr>
					<th></th>
					<th >Class</th>
					<th >Order # <br> Reg Date</th>
					<th >Amount</th>
					<th >Methods/Notes</th>
					<th >Sales Rep</th>
					<th >Seats</th>
					<th> Salon Name <br> Attendee(s) </th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let r of sortedReportResults">
					<td><button mat-stroked-button class="btn btn-small btn-primary" (click)="viewAttendees(r)"><mat-icon>edit</mat-icon></button><br><br><button mat-stroked-button class="btn btn-small btn-danger" (click)="removeAllReg(r.history_id)"><mat-icon>delete</mat-icon></button></td>
					<td>{{ r.class }}<br> {{r.location}}<br>{{r.city}}<br>{{r.event_date}}</td>
					<td>{{ r.order_id }}<br>{{ r.date_added }}<br><a target="_blank" href="{{r.print}}">Reprint</a></td>
					<td>{{ r.total | currency}}</td>
					<td><span [innerHtml]="r.methods"> </span></td>
					<td>{{ r.salesmanname }}</td>
					<td>{{ r.seats }}</td>
					<td>({{r.customerid}}) {{ r.name }}<br><span [innerHtml]="r.registrant"></span></td>
				</tr>
			</tbody>
		</table>
	</div>
	<div #print_table class="d-none">
		<table class="table table-striped table-bordered table-hover table-fixed" *ngIf="!loading">
			<thead>
				<tr>
					<th >Class</th>
					<th >Order # <br> Reg Date</th>
					<th >Amount</th>
					<th >Methods/Notes</th>
					<th >Sales Rep</th>
					<th >Seats</th>
					<th> Salon Name <br> Attendee(s) </th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let r of sortedReportResults">
					<td>{{ r.class }}<br> {{r.location}}<br>{{r.city}}<br>{{r.event_date}}</td>
					<td>{{ r.order_id }}<br>{{ r.date_added }}<br><a target="_blank" href="{{r.print}}">Reprint</a></td>
					<td>{{ r.total | currency}}</td>
					<td><span [innerHtml]="r.methods"> </span></td>
					<td>{{ r.salesmanname }}</td>
					<td>{{ r.seats }}</td>
					<td>({{r.customerid}}) {{ r.name }}<br><span [innerHtml]="r.registrant"></span></td>
				</tr>
			</tbody>
		</table>
	</div>
	</div>
	</div>
	</div>